const venue = {
  state: {
    venue: sessionStorage.getItem("venue")
      ? JSON.parse(sessionStorage.getItem("venue"))
      : {},
  },
  mutations: {
    SET_VENUE: (state, venue) => {
      state.venue = venue;
      sessionStorage.setItem("venue", JSON.stringify(venue));
    },
  },
  actions: {},
};

export default venue;
